import type { HTMLAttributes, ReactNode } from 'react';

type DataTableTableCellProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
    children: ReactNode;
};

export function DataTableCell({ children, ...props }: DataTableTableCellProps) {
    return <div {...props}>{children}</div>;
}
